import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/esm/Tooltip";
import UserInfoComponent from "../../homepageComponents/UserInfoComponent";
import UserAttendanceComponent from "../../homepageComponents/UserAttendanceComponent";


function HeaderComponent() {
 
  
  return (
    <>
      <header className="d-lg-block d-none">
        <div className="container-fluid">
          <div className="row">
          <div className="col-lg-4  text-center align-self-center">

<UserInfoComponent/>

</div>
<div className="col-lg-2  text-center align-self-center">

<UserAttendanceComponent/>

</div>


            <div className="col-lg-6  text-center align-self-center">
              <div className="left-headerx d-flex justify-content-end">


                <div className="navbar-thc">
                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"> شركة تطوير التعليم القابضة </Tooltip>}>
                  <a
                    href="/"
                    className="navbar-item-thc tatweer"
                    aria-label="Tatweer"
                  ></a>
                  </OverlayTrigger>

                  <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-tetco"> شركة تيتكو تطوير تقنيات التعليم  </Tooltip>}>
                  <a
                    href="https://portal.tetco.sa" target="blank"
                    className="navbar-item-thc tetco"
                    aria-label="Tetto"
                  ></a>
                  </OverlayTrigger>

                  <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-tbc"> شركة تطوير للمباني </Tooltip>}>
                  <a
                    href="https://Portal.tbc.sa" target="blank"
                    className="navbar-item-thc tbc"
                    aria-label="TBC"
                  ></a>
                  </OverlayTrigger>

                  <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-rafed"> شركة رافد لخدمات النقل التعليم  </Tooltip>}>
                  <a
                    href="https://eportal.rafedsa.com" target="blank"
                    className="navbar-item-thc rafed"
                    aria-label="Rafed"
                  ></a>
                  </OverlayTrigger>

                  <OverlayTrigger placement="right" overlay={<Tooltip  id="tooltip-talemia" > شركة التعليمية </Tooltip>}>
                  <a
                    href="https://hrsurvey.talemia.sa/socialscreen/home/portal" target="blank"
                    className="navbar-item-thc talemia"
                    aria-label="Talemia"
                  ></a>
                  </OverlayTrigger>
                </div>

           

              </div>
              

            </div>

  


          </div>
        </div>
      </header>
    </>
  );
}

export default HeaderComponent;
